// vue and router
import Vue from 'vue';
import VueRouter from 'vue-router';
// store
import store from "@/store.js";

// * Core Views
// ? Imports are listed in the same order as in the HOME PAGE and APP MENU
import Home from '@/views/home.vue'; // * Home
import Swapp from "@/views/swapp.vue"; // * SWAPP IN/OUT
import Induction from "@/components/induction.vue"; // * Induction  
import Quiz from "@/components/quiz.vue"; // * Quiz  
import Todos from "@/views/todos.vue"; // * To Do
import Notifications from "@/views/notifications.vue"; // * Notifications
import Projects from "@/views/projects/projects.vue"; // * Project Views
import ProjectPage from "@/views/projects/project-page.vue";
import Documents from "@/views/projects/documents.vue";
import ProjectAccess from "@/views/projects/access.vue";
import Permits from "@/views/projects/permits.vue";
import Team from "@/views/projects/team.vue";
import Slides from "@/views/slides.vue"; // * Slides 
import Questions from "@/views/questions.vue"; // * Slides 
import Concerns from "@/views/concerns.vue"; // * Concerns
import Notices from "@/views/notices.vue"; // * Notices
import Guides from "@/views/guides.vue"; // * GUIDES
import Files from "@/views/files.vue"; // * Files
import Sites from "@/views/sites.vue"; // * Sites
import Organisations from "@/views/organisations.vue"; // * Organisations
import Users from "@/views/users.vue"; // * Users
import SiteAccess from "@/views/access.vue"; // * Site Access
import Passes from "@/views/passes.vue"; // * Passes
import FireRollCalls from "@/views/fireRollCalls.vue"; // * Fireroll Call
import fireRollCallRegister from "@/components/fireRollCallRegister.vue"; // * Fireroll Call Register
import Settings from "@/views/settings/settings.vue"; // * Settings 
import Lookups from "@/views/settings/lookups.vue";
import Help from "@/views/help.vue"; // * Help
import Simulator from "@/views/simulator.vue"; // * Simulator
import Profile from "@/views/profile.vue"; // * Profile
import SwappLog from "@/views/swappLog.vue"; // * Swapp Log
import LiveRollCall from "@/views/liveRollCall.vue"; // * Live Roll Call
import BulkUserQR from "@/views/bulkUserQR.vue"; // * Live Roll Call
// import Reports from "@/views/reports.vue"; // * Live Roll Call

// * AUTH VIEWS
//import Register from "@/views/auth/main-register.vue";
import Login from "@/views/auth/login.vue";
import Register from "@/views/auth/register.vue";
import ResetPassword from "@/views/auth/reset-password.vue";
//import AddOrganisation from "@/views/auth/add-organisation.vue";

Vue.use(VueRouter)

// ? Routes are listed in the same order as in the HOME PAGE and APP MENU
const routes = [
  { path: '/', name: 'Home', component: Home, meta: {requiresAuth: true } },
  { path: '/swapp/:direction?', name: 'Swapp', component: Swapp, meta: {requiresAuth: true } },
  { path: '/induction', name: 'Induction', component: Induction },
  { path: '/quiz', name: 'Quiz', component: Quiz },
  { path: '/todos', name: 'Todos', component: Todos, meta: {requiresAuth: true } },
  { path: '/projects', name: 'Projects', component: Projects, meta: {requiresAuth: true } },
  { path: '/projects/:id', name: 'ProjectPage', component: ProjectPage, meta: {requiresAuth: true },
    children: [
      { path: '/projects/:id/documents/:docId?', name: 'Documents', component: Documents, meta: {requiresAuth: true } },
      { path: '/projects/:id/access', name: 'Access', component: ProjectAccess, meta: {requiresAuth: true } },
      { path: '/projects/:id/permits', name: 'Permits', component: Permits, meta: {requiresAuth: true } },
      { path: '/projects/:id/team', name: 'Team', component: Team, meta: {requiresAuth: true }},
    ]
  },
  // * Slides
  { path: '/slides', name: 'Slides', component: Slides, meta: {requiresAuth: true}},
  { path: '/questions', name: 'Questions', component: Questions, meta: {requiresAuth: true}},
  { path: '/concerns/:id?', name: 'Concerns', component: Concerns, meta: {requiresAuth: true } },
  { path: '/notices/:id?', name: 'Notices', component: Notices, meta: {requiresAuth: true } },
  { path: '/files', name: 'Files', component: Files, meta: {requiresAuth: true } },
  { path: '/sites/:id?', name: 'Sites', component: Sites, meta: {requiresAuth: true } },
  { path: '/organisations/:id?', name: 'Organisations', component: Organisations, meta: {requiresAuth: true } },
  { path: '/users/:id?', name: 'Users', component: Users, meta: {requiresAuth: true } },
  { path: '/passes/:id?', name: 'Passes', component: Passes, meta: {requiresAuth: true } },
  { path: '/access/:id?', name: 'Site Access', component: SiteAccess, meta: {requiresAuth: true } },  
  { path: '/firerollcall', name: 'Fire Roll Call', component: FireRollCalls, meta: {requiresAuth: true } },
  { path: '/fireRollCallRegister', name: 'Fire Roll Call Register', component: fireRollCallRegister, meta: {requiresAuth: true } },
  { path: '/settings', component: Settings, meta: {requiresAuth: true } },
  { path: '/settings/lookups', name: 'Lookups', component: Lookups, meta: {requiresAuth: true } },
  { path: '/help', name: 'Help', component: Help, meta: {requiresAuth: true } },
  { path: '/guides/:id?', name: 'Guides', component: Guides, meta: {requiresAuth: true } },
  { path: '/simulator', name: 'Simulator', component: Simulator, meta: {requiresAuth: true } },
  { path: '/notifications', name: 'Notification', component: Notifications, meta: {requiresAuth: true } },
  { path: '/swappLog', name: 'SwappLog', component: SwappLog, meta: {requiresAuth: true } },
  { path: '/liveRollCall/:id', name: 'LiveRollCall', component: LiveRollCall, meta: {requiresAuth: true } },
  { path: '/bulkUserQR', name: 'BulkUserQR', component: BulkUserQR, meta: {requiresAuth: true } },
//   { path: '/reports', name: 'Reports', component: Reports, meta: {requiresAuth: true } },
  { path: '/register', name: 'Register', component: Register },
  { path: '/login', name: 'Login', component: Login},
  { path: '/profile', name: 'Profile', component: Profile},
  { path: '/reset-password', name: 'ResetPassword', component: ResetPassword},
//   { path: '/add-organisation', name: 'AddOrganisation', component: AddOrganisation},
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
  if (requiresAuth) {
    let checkUser = store.getters.GET_currentUser;
    navigator.serviceWorker.register('/service-worker.js').then(reg => {
      // sometime later…
      reg.update();
    });
    if (!checkUser) {
      next("/login");
    } else {
      next();
    }
  } else next();
});

export default router;
